/**
 * Lightweight logger that gates console output to dev builds only.
 *
 * Production builds (NODE_ENV === 'production') get a no-op so we don't
 * leak internal error context to end users via DevTools. Use this instead
 * of `console.*` directly.
 *
 *   import { logger } from '../lib/logger';
 *   logger.error('Failed to load X', err);
 */
const isProd = process.env.NODE_ENV === 'production';

const noop = () => {};

export const logger = {
  log: isProd ? noop : (...args) => console.log(...args),
  info: isProd ? noop : (...args) => console.info(...args),
  warn: isProd ? noop : (...args) => console.warn(...args),
  error: isProd ? noop : (...args) => console.error(...args),
  debug: isProd ? noop : (...args) => console.debug(...args),
};
